import type React from 'react';

import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { CaseLayout } from '@/components/shared';
import { I18nProvider } from '@/core/providers';
import { DefinitionsProvider } from '@/core/providers/DefinitionsProvider';
import { OriginTenantSlugProvider } from '@/core/providers/OriginTenantSlugProvider';
import { useSettings } from '@/core/providers/SettingsProvider';
import { CaseRequestRoute } from '@/routes/companyLanding/CaseRequestRoute';
import { CaseRequestSuccessRoute } from '@/routes/companyLanding/CaseRequestSuccessRoute';
import { companyLandingPaths } from '@/routes/companyLanding/paths';
import { SignUpRoute } from '@/routes/companyLanding/SignUpRoute';
import { NotFoundRoute } from '@/routes/NotFoundRoute';

const Providers: React.FC = () => {
	const settings = useSettings();
	if (settings.mode !== 'companyLanding') {
		throw new Error('App mode is not companyLanding');
	}

	return (
		<OriginTenantSlugProvider originTenantSlug={settings.tenant}>
			<I18nProvider defaultLocale={settings.defaultLocale}>
				<DefinitionsProvider>
					<Outlet />
				</DefinitionsProvider>
			</I18nProvider>
		</OriginTenantSlugProvider>
	);
};

export const CompanyLandingRouter: React.FC = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Providers />}>
					<Route path="*" element={<NotFoundRoute />} />

					<Route path={companyLandingPaths.signUp()} element={<SignUpRoute />} />

					{/* Case-related routes */}
					<Route element={<CaseLayout />}>
						<Route path={companyLandingPaths.caseRequest(':requestId')} element={<CaseRequestRoute />} />
						<Route path={companyLandingPaths.requestSubmitted()} element={<CaseRequestSuccessRoute />} />
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
	);
};
